export default __webpack_public_path__ + "static/media/uploadtimesheet.db0713f1.svg";